import React, { useEffect, useRef, useState } from "react";
import "./CustomSelect.scss";
import { useClickOutside } from "use-events";

import { FaAngleDown } from "react-icons/fa6";

const CustomSelect = ({
  name,
  required,
  register,
  value,
  handleChange,
  options,
  reset,
  isForm,
  ...rest
}) => {
  const selectRef = useRef(null);

  const [openOption, setOpenOption] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    label: "",
    value: "",
  });

  useClickOutside([selectRef], (event) => {
    setOpenOption(false);
  });

  const handleOptionClick = (data) => {
    handleChange(data);
    reset(`${name}`, data.value);
    setOpenOption(false);
  };

  useEffect(() => {
    if (value.value !== "" && required) {
      register(name, { required: false });
    } else {
      register(name, { required: required });
    }
    setSelectedValue(value);
  }, [value]);

  return (
    <div className="custom-select" ref={selectRef}>
      <div
        className="showSelected"
        onClick={() => {
          setOpenOption(!openOption);
        }}
      >
        {selectedValue.label}
      </div>
      <div className={`options ${openOption ? "open" : ""}`}>
        {isForm && <div
          className={`option ${selectedValue.value === "" ? "active" : ""}`}
          onClick={() => {
            handleOptionClick({ label: "Select", value: "" });
          }}
        >
          Select
        </div>}
        {options?.map((opt, i) => {
          return (
            <div
              className={`option ${
                opt.value === selectedValue.value ? "active" : opt.value === "add_category" ? "select-button" : ""
              }`}
              key={i}
              onClick={() => {
                handleOptionClick(opt);
              }}
            >
              {opt.label}
            </div>
          );
        })}
      </div>
      <div className={`select-icon ${openOption ? "open" : ""}`}>
        <FaAngleDown />
      </div>
    </div>
  );
};

export default CustomSelect;
